// ============================================================
// useTransactions Hook
// ============================================================

import { useQuery } from '@tanstack/react-query';
import { useSchool } from './useSchool';
import { feeService } from '@/services/feeService';

export function useTransactions() {
  const { currentSchool } = useSchool();

  return useQuery({
    queryKey: ['transactions', currentSchool?.id],
    queryFn: () => feeService.getTransactions(currentSchool.id),
    enabled: !!currentSchool?.id,
    select: (res) => res.data,
  });
}
